import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import '../../Assets/css/resptable.css'
import '../../Assets/css/responsiveptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import { useParams } from 'react-router-dom';

export default function PaymentReceiptList() {

  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/");
  }

  const tableRef = useRef(null);



  const [disciplineId, setDisciplineChange] = useState(null);
  const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [flag, setflag] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [loading, setlodaing] = useState(false);

  const [getexamData, setExamData] = useState([]);

  const [showModal, setShowModal] = useState(false);

  const [collegeData, setCollegeData] = useState(null);
  const [studentData, setStudentData] = useState([]);


  const { http } = Api();

  let cid = localStorage.getItem("collegeid");
  const [transactionReceipt, setSelectedTransactionReceipt] = useState(null);




  const { encodedID } = useParams();

  const { eid, tid } = useParams();  // Get encoded IDs from URL
  const decodedExamID = atob(eid);    // Decode exam ID
  const decodedTransactionID = atob(tid);


  //  alert(decodedExamID);
  //  alert(decodedTransactionID);

  useEffect(() => {

    const fetchExamData = async () => {
      try {
        const response = await http.get(`College/StudentFeePaymentDetails`,
          {
            params: {
              examid: decodedExamID,
              txnid: decodedTransactionID

            }
          }
        );

        const data = response.data[decodedTransactionID];
        console.log(response);
        setCollegeData(data);
        setStudentData(data.studentList || []);
      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
          toast.error("No active exam found");
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchExamData();
  }, []);

   const handleGeneratePDFNew = async (examid, transNo, collegename, programme) => {
     setlodaing(true);
     try {
       const response = await http.get('/College/StudentFeePaymentDetailspdf', {
         params: {
           // examid: examid,
           // txnid: transNo
              examid: decodedExamID,
              txnid: decodedTransactionID
         },
         responseType: 'blob'
       });

       if (response && response.data) {

         const url = window.URL.createObjectURL(new Blob([response.data]));
       const link = document.createElement('a');
         link.href = url;
         link.setAttribute('download', `${localStorage.getItem('username')}_${collegename}_${programme}.pdf`);
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
         setlodaing(false);

         return Promise.resolve('PDF generated successfully ');


       }

     } catch (error) {
       console.error('Error generating PDF:', error);
       return Promise.reject('Error generating PDF');
     }
   };

 // console.log("collegeData", collegeData);
  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (


          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (


          <div className="my-page">

            <div className="container-fluid">



              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Students Fee Payment Details</h5>
                          <div className="buttons-container">




                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="card-body pdg">
                          <div className="table-responsive">
                            <div className="form theme-form">
                              <div className="card-body custom-input">
                                <div className="pnt-btn">
      <button
                                    className="bill-print-button"
                                    onClick={handleGeneratePDFNew}
                                  >
                                    <i className="fa fa-print" aria-hidden="true"></i> &nbsp;  &nbsp;
                                    Print
                                  </button> 
                                </div>

                                <div class="table-container">
                                  <table className="" ref={tableRef} id="dataTable">
                                    <tbody className="ln-ht">
                                      <tr className="">
                                        <td scope="col" width=""><b>Exam</b></td>
                                        <td scope="col" colSpan={3}>{collegeData?.examtitle || 'N/A'}</td>
                                      </tr>
                                      <tr>
                                        <td><b>Receipt No.</b></td>
                                        <td>{collegeData?.receiptNo || 'N/A'}</td>
                                        <td scope="col"><b>Transaction date</b></td>
                                        <td scope="col">{collegeData?.payment_time || 'N/A'}</td>
                                      </tr>
                                      <tr>
                                        <td><b>College</b></td>
                                        <td>{collegeData?.college_name || 'N/A'}</td>
                                        <td scope="col"><b>Programme</b></td>
                                        <td scope="col">{collegeData?.programme || 'N/A'}</td>
                                      </tr>
                                      <tr>
                                        <td><b>No. of Students</b></td>
                                        <td>{collegeData?.studentcount || 0}</td>
                                        <td scope="col"><b>Amount</b></td>
                                        <td scope="col">{collegeData?.amttotal || 0}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="table-container m-t-30" style={{ overflowX: 'unset' }}>
                                  <table className=" dataTable   ex-v-table " ref={tableRef} id="dataTable">
                                    <thead>
                                      <tr className="bg-primary">
                                        <th scope="col" width="10%">Sl No</th>
                                        <th scope="col" width="30%">APAAR No</th>
                                        <th scope="col" width="15%">Student Name</th>
                                        <th scope="col" width="10%">Fee Amount</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {studentData.length > 0 ? (
                                        studentData.map((student, index) => (
                                          <tr key={index}>
                                            <td scope="row" className="text-center">{index + 1}</td>
                                            <td data-label="PRN">{student.apaar_no || 'N/A'}</td>
                                            <td data-label="Student Name" className="text-center">{student.studentname || 'N/A'}</td>
                                            <td>{student.amount || 0}</td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="4" className="text-center">No data available</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                  {showModal && transactionReceipt && (
                                    <div className="modal fade show d-block" style={{ backdropFilter: 'blur(2px)' }}>
                                      <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5 className="modal-title">Bill Details</h5>
                                            <button type="button" className="close" onClick="">&times;</button>
                                          </div>
                                          <div className="modal-body">
                                            <table className="table table-bordered">
                                              <tbody>
                                                <tr>
                                                  <th>Bank Name</th>
                                                  <td>{transactionReceipt.bankName}</td>
                                                </tr>
                                                <tr>
                                                  <th>Transaction Id</th>
                                                  <td>{transactionReceipt.transId}</td>
                                                </tr>
                                                <tr>
                                                  <th>Transaction No.</th>
                                                  <td>{transactionReceipt.transNo}</td>
                                                </tr>
                                                <tr>
                                                  <th>Bank Receipt. No.</th>
                                                  <td>{transactionReceipt.receiptNo}</td>
                                                </tr>
                                                <tr>
                                                  <th>College</th>
                                                  <td>{transactionReceipt.collegename}</td>
                                                </tr>
                                                <tr>
                                                  <th>Programme</th>
                                                  <td>{transactionReceipt.programme}</td>
                                                </tr>
                                                <tr>
                                                  <th>No. of Students</th>
                                                  <td>{transactionReceipt.studentcount}</td>
                                                </tr>
                                                <tr>
                                                  <th>Amount</th>
                                                  <td>{transactionReceipt.amt}</td>
                                                </tr>
                                                <tr>
                                                  <th>Transaction Date</th>
                                                  <td>{transactionReceipt.responseTime}</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                          <div className="modal-footer">
                                            <button className="btn btn-danger" onClick="">Print</button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </Template>
    </>
  );
}
